import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Grid, Stack, Tooltip, Typography } from '@mui/material';
import {
  deleteTelefonosAction,
  allTelefonosAction,
  setActivoTelefonosAction,
} from '../TelefonosAction';
import * as CONST from '../../../constants/FieldsConst';
import { textLabels } from '../../../helpers';
import { LoadingWidget } from '../../../widgets';
import { Chip } from '@mui/material';
import ActionsListWidget from '../../../widgets/ActionsList';
import { useNotification } from '../../../helpers/Notification';
import DeleteModalComponent from '../../../widgets/modals/DeleteModal';

const ListadoTelefonos = ({ setOpenModalForm, params }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const telefonosStore = Redux.useSelector((state) => state.telefonos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (telefonosStore.all && telefonosStore.all.length === 0) {
        await allTelefonosAction(dispatch, {
          ...telefonosStore.params,
          ...params,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    telefonosStore.all.forEach((el) =>
      rowsData.push({
        ...el,
        operadora: `${el.operadora.nombre} (${el.operadora.prefijo})`,
        actions: el,
      }),
    );
    setRows(rowsData);
  }, [telefonosStore.all]);

  const _handleEditClick = async (value) => {
    await setActivoTelefonosAction(dispatch, value);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteTelefonosAction(
      { dispatch, notify },
      telefonosStore.activo.id,
      {
        ...telefonosStore.params,
        ...params,
      },
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    // {
    //   name: CONST.operadora.name,
    //   label: CONST.operadora.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },
    {
      name: CONST.numero.name,
      label: CONST.numero.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.isPrincipal.name,
      label: CONST.isPrincipal.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? (
            <Tooltip
              describeChild
              title={value ? 'Número principal' : 'No principal'}
              placement="top"
            >
              <Chip label="Principal" size="small" color="success" />
            </Tooltip>
          ) : (
            <label>--</label>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(value)}
                onDelete={async () => {
                  await setActivoTelefonosAction(dispatch, value);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={telefonosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {telefonosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{telefonosStore.activo.numero}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoTelefonos;
